import { Grid } from '@mui/material'
import React from 'react'
import MenuTable from '../Menu/MenuTable'
import OrderTable from '../Orders/OrderTable'

const RestaurantDashboard = () => {
  return (
    <div>
      <Grid container spacing={12}>
        <Grid item xs={12} lg={6}>
          <MenuTable/>
        </Grid>
        <Grid item xs={12} lg={6}>
          <OrderTable/>
        </Grid>
      </Grid>
    </div>
  )
}

export default RestaurantDashboard
